import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-image-column',
  templateUrl: './user-image-column.component.html',
  styleUrls: ['./user-image-column.component.scss']
})
export class UserImageColumnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
